<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        append-to-body
        center
        class="detail-dialog-container"
        width="50%">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">{{ detail.server_title }}</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction">
                <div class="content">{{ detail.server_content }}</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>

import {getMemberServiceContentDetail} from "@/api/data";

export default {
    name: "MoreServiceDetailDialog",
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        id: { //详情ID
            type: Number,
        }
    },
    data() {
        return {
            detail: '',
        }
    },
    created() {
        if (this.id) this.init()
    },
    methods: {
        async init() {
            let _data = await getMemberServiceContentDetail(this.id)
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },

    },
    watch: {
        id() {
            if (this.id) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            height: 505px;
            padding: 0 20px;

            .content {
                font-size: 16px;
                line-height: 36px;
                color: #666666;
                text-align: justify;
            }
        }
    }
}
</style>